import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const loadBoardSettings = () => import( /* webpackChunkName: "crm-object-board-settings" */'crm-object-board/crmObjectPropertyBoard/BoardSettings').then(mod => mod.BoardSettings);

// Fallback component while loading
// Pending UX input: Maybe a nicer skeleton loader?
const FallbackSettings = __props => /*#__PURE__*/_jsx(LoadingSpinner, {});
export const AsyncBoardSettings = Loadable({
  loader: loadBoardSettings,
  LoadingComponent: FallbackSettings,
  ErrorComponent: FallbackSettings
});